export default {
  'purchasingGrouping.form.company': 'Company',
  'purchasingGrouping.form.supplier': 'Supplier',
  'purchaseReturn.form.releaseDateOf.start': 'Release Date Of (From)',
  'purchaseReturn.form.releaseDateOf.end': 'Release Date Of (To)',

  'purchaseReturn.form.table.workOrder': 'Budget',
  'purchaseReturn.form.table.purchaseCode': 'Purchase Code',
  'purchaseReturn.form.table.purchaseDate': 'Purchase Date',
  'purchaseReturn.form.table.manufacturingCode': 'Manu. Code',
  'purchaseReturn.form.table.description': 'Description',
  'purchaseReturn.form.table.qtyPurchased': 'Qty. Purchased',
  'purchaseReturn.form.table.qtyReturned': 'Qty. Returned',
  'purchaseReturn.form.table.qtyToReturn': 'Qty. to Return',

  'purchasingGrouping.form.button.generateInvoice': 'Generate Invoice',
  'purchaseReturn.form.button.updateData': 'Update Data',
};
